function initRelatedProductsSlider (element) {
    mySwiper = new Swiper(element.querySelector('.swiper'), {
        slidesPerView: 1,
        spaceBetween: 20,
        watchOverflow: true,
        preloadImages: false,
        checkInView: true,
        loadPrevNext: true,
        lazy: true,
        breakpoints: {
            470: {
                slidesPerView: 2,
                spaceBetween: 20,
            },
            600: {
                slidesPerView: 2,
                spaceBetween: 50,
            },
            1000: {
                slidesPerView: 3,
                spaceBetween: 30,
            },
            1200: {
                slidesPerView: 3,
                spaceBetween: 90,
            },
            1500: {
                slidesPerView: 3,
                spaceBetween: 110,
            },
            1700: {
                slidesPerView: 3,
                spaceBetween: 140,
            },
            1910: {
                slidesPerView: 3,
                spaceBetween: 155,
            },
        },
        navigation: {
            nextEl: element.querySelector('.swiper-button-next'),
            prevEl: element.querySelector('.swiper-button-prev'),
        },
    });
}

window.addEventListener('load', function () {
    if (document.querySelectorAll('.relatedProductsSlider').length) {
        const relatedProductsSlider = document.querySelectorAll('.relatedProductsSlider');

        relatedProductsSlider.forEach(function(element) {
            initRelatedProductsSlider(element);
        });
    }
});
